import { type RefObject, useEffect, useMemo, useState } from 'react'

/**
 * Hook to analyse when a component is visible on the dom
 */
export const useOnScreen = (
  ref: RefObject<HTMLElement | null>,
  options?: IntersectionObserverInit,
) => {
  const [isIntersecting, setIntersecting] = useState(false)

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) => {
        setIntersecting(entry.isIntersecting)
      }, options),
    [options],
  )

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => observer.disconnect()
  }, [ref, observer])

  return isIntersecting
}
